import { appContent } from '@/mocks/homeData';

const appImage = 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20colorful%20manga%20comic%20reader%20app%20interface%2C%20warm%20orange%20and%20coral%20UI%20theme%2C%20comic%20page%20with%20dynamic%20action%20scene%20visible%20on%20screen%2C%20clean%20white%20phone%20frame%2C%20floating%20on%20soft%20cream%20background%20with%20subtle%20gradient%2C%20modern%20app%20presentation%20style&width=600&height=800&seq=app-mockup&orientation=portrait';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/40">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">星星动漫网 APP</h2>
            <p className="mt-2 text-lg font-heading text-primary-600">{appContent.subtitle}</p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg mx-auto lg:mx-0">{appContent.desc}</p>
            <div className="mt-5 flex flex-wrap gap-3 justify-center lg:justify-start">
              {appContent.features.map((feat) => (
                <span key={feat} className="text-xs px-3 py-1.5 rounded-full bg-background-50 border border-background-300 text-foreground-600 flex items-center gap-1">
                  <i className="ri-check-line text-accent-500 text-sm"></i>{feat}
                </span>
              ))}
            </div>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="px-7 py-3 bg-foreground-900 hover:bg-foreground-800 text-background-50 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill mr-2"></i>App Store 下载
              </button>
              <button className="px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-google-play-fill mr-2"></i>Google Play 下载
              </button>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="relative max-w-[260px] md:max-w-[300px]">
              <div className="rounded-3xl overflow-hidden border-4 border-background-200 shadow-2xl">
                <img
                  src={appImage}
                  alt="星星动漫网APP界面展示"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
              <div className="absolute -top-4 -right-4 w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-primary-500 flex items-center justify-center shadow-lg">
                <i className="ri-smartphone-line text-background-50 text-2xl md:text-3xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}